import { Caption as e, Small as t } from "../../Typography/Typography.mjs";
import { Button as n } from "../Button/Button.mjs";
import { CopyButton as r } from "../Button/CopyButton.mjs";
import { useIsOverflowing as i } from "./hooks/useIsOverflowing.mjs";
import { Footer as a, Frame as o, Header as s, HeaderLabel as c, Pre as l } from "./CodeBlock.styled.mjs";
import { useState as u } from "react";
import { useTranslation as d } from "@maat/store-i18n";
import { jsx as f, jsxs as p } from "react/jsx-runtime";
//#region src/components/CodeBlock/CodeBlock.tsx
var m = ({ code: m, label: h, meta: g, maxHeight: _ = 320, copyable: v = !0, wrap: y = !1, className: b }) => {
	let { t: x } = d("ds"), [S, C] = u(!1), { ref: w, overflowing: T } = i(_, m);
	return /* @__PURE__ */ p(o, {
		className: b,
		children: [
			h || g || v ? /* @__PURE__ */ p(s, { children: [
				/* @__PURE__ */ f(c, { children: h ? /* @__PURE__ */ f(t, {
					weight: "medium",
					color: "secondary",
					clamp: 1,
					children: h
				}) : null }),
				g ? /* @__PURE__ */ f(e, { children: g }) : null,
				v ? /* @__PURE__ */ f(r, {
					value: m,
					iconSize: 14
				}) : null
			] }) : null,
			/* @__PURE__ */ f(l, {
				ref: w,
				$wrap: y,
				$maxHeight: S ? void 0 : _,
				children: m
			}),
			T ? /* @__PURE__ */ f(a, { children: /* @__PURE__ */ f(n, {
				variant: "ghost",
				size: "sm",
				onClick: () => C((e) => !e),
				children: x(S ? "ds:codeBlock.showLess" : "ds:codeBlock.showAll")
			}) }) : null
		]
	});
};
//#endregion
export { m as CodeBlock };
